import styled from 'styled-components'
import { TableBodyCell as Cell, TableBodyRow as Row } from 'src/components/TableComponents'

export const TableBodyCell = styled(Cell).attrs<{ flex: number; textAlign: string }>(
  ({ flex, textAlign = 'start' }) => ({
    style: {
      textAlign,
      fontFamily: 'Work Sans',
      color: '#000000DE',
      fontSize: 12,
      flex,
      display: 'flex',
    },
  }),
)``

export const ObservationsTableBodyRow = styled(Row).attrs(() => ({
  style: {
    cursor: 'pointer',
  },
}))``

export const Observations = styled.span`
  font-size: 14px;
  font-family: Work Sans;
  color: ${({ theme }) => theme.colors.red2};
  font-weight: bold;
`

export const ObservationsValueTableBodyRow = styled(Row).attrs(() => ({
}))``

export const Image = styled.img`
  width: 18px;
  height: 18px;
`

export const ImageCheck = styled.img`
  width: 12px;
  height: 12px;
`

export const ImageContainer = styled.div`
  position: absolute;
  margin-left: 14px;
  margin-top: -8px;
`
